import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-p404',
  templateUrl: './p404.component.html',
  styleUrls: ['./p404.component.scss']
})
export class P404Component implements OnInit {
  cordCanvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  y1 = 160;
  y2 = 100;
  y3 = 100;

  y1Forward = true;
  y2Forward = false;
  y3Forward = true;
  constructor() { }

  ngOnInit(): void {
    this.drawVisor();
    this.animate();
  }

  drawVisor() {
    const canvas = document.getElementById('visor') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    ctx.beginPath();
    ctx.moveTo(5, 45);
    ctx.bezierCurveTo(15, 64, 45, 64, 55, 45);

    ctx.lineTo(55, 20);
    ctx.bezierCurveTo(55, 15, 50, 10, 45, 10);

    ctx.lineTo(15, 10);

    ctx.bezierCurveTo(15, 10, 5, 10, 5, 20);
    ctx.lineTo(5, 45);

    ctx.fillStyle = '#2f3640';
    ctx.strokeStyle = '#f5f6fa';
    ctx.fill();
    ctx.stroke();
  }

  animate = () => {
    this.cordCanvas = document.getElementById('cord') as HTMLCanvasElement;
    this.ctx = this.cordCanvas.getContext('2d');

    requestAnimationFrame(this.animate);
    this.ctx.clearRect(0, 0, innerWidth, innerHeight);

    this.ctx.beginPath();
    this.ctx.moveTo(130, 170);
    this.ctx.bezierCurveTo(250, this.y1, 345, this.y2, 400, this.y3);

    this.ctx.strokeStyle = 'white';
    this.ctx.lineWidth = 8;
    this.ctx.stroke();

    if (this.y1 === 100) {
      this.y1Forward = true;
    }

    if (this.y1 === 300) {
      this.y1Forward = false;
    }

    if (this.y2 === 100) {
      this.y2Forward = true;
    }

    if (this.y2 === 310) {
      this.y2Forward = false;
    }

    if (this.y3 === 100) {
      this.y3Forward = true;
    }

    if (this.y3 === 317) {
      this.y3Forward = false;
    }

    this.y1Forward ? this.y1 += 1 : this.y1 -= 1;
    this.y2Forward ? this.y2 += 1 : this.y2 -= 1;
    this.y3Forward ? this.y3 += 1 : this.y3 -= 1;
  }

}
